import { O } from '@angular/cdk/keycodes';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { PlannerHelpingService } from './planner-helping-service';
@Injectable({
  providedIn: 'root'
})
export class PlannerSameLegsService {

  user;
  preData;
  preFleet;
  selectedMapper;
  violation;
  selectedDrivers;
  selectedMethod;
  timeCalibration;
  shiftMapper
  constructor(private  assigTripsService:AssigTripsService,
      private plannerHelpingService: PlannerHelpingService) {
  }



  async planTrips(user, preData, preFleet, violation, selectedMapper, selectedDrivers, selectedMethod,timeCalibration, shiftMapper) {
    const memberTripsMap = {};
    this.user = user;
    this.preData = preData;
    this.preFleet = preFleet;
    this.violation = violation;
    this.timeCalibration = timeCalibration;
    this.selectedMapper = selectedMapper;
    this.selectedDrivers = selectedDrivers;
    this.selectedMethod = selectedMethod;
    this.shiftMapper = shiftMapper


    let planedTrips = {
      trips: {},
      nonCompatible: [],
      compatible: {},
      tripLogs: {},
      driversDistance: {}
    };
    const incomingTrips = [];


    for (let trip of this.preData.trips) {
      if (this.preData.selectedTrips.includes(trip._id)) {
        incomingTrips.push(trip);
      }
    }

  //  if (this.timeCalibration && this.timeCalibration !== "none"){
  //     // set pickup and drop off time
  //     for (let trip of incomingTrips) {
  //       const distance = await this.calculateDistance(
  //         trip.jobOriginLatitude,
  //         trip.jobOriginLongitude,
  //         trip.jobDestinationLatitude,
  //         trip.jobDestinationLongitude
  //       );

  //      if (distance && distance.duration) {
  //              if (timeCalibration === "pickup-wise") {
  //                trip.scheduleTime = moment(trip.appointmentTime).tz(user.timeZone).subtract(distance.duration, 'minutes').toISOString();
  //              } else {
  //                trip.appointmentTime = moment(trip.scheduleTime).tz(user.timeZone).add(distance.duration, 'minutes').toISOString();
  //              }
  //       }
  //     }
    //   }

    if (this.timeCalibration && this.timeCalibration !== "none") {
      if (this.timeCalibration === "pickup-wise") {
        await this.plannerHelpingService.applyPickupWiseCalibration(this.selectedMethod, incomingTrips, user);
      } else if (this.timeCalibration === "dropoff-wise") {
        await this.plannerHelpingService.applyDropoffWiseCalibration(this.selectedMethod, incomingTrips, user);
      } else {
        await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.selectedMethod, incomingTrips, user);
      }
    }

    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    incomingTrips.sort((a, b) => {
      return moment(a.scheduleTime).tz(this.user.timeZone).diff(moment(b.scheduleTime).tz(this.user.timeZone));
    });

    for (let trip of incomingTrips) {
      const memberId = trip.client;

      if (!memberTripsMap[memberId]) {
        memberTripsMap[memberId] = [];
      }

      memberTripsMap[memberId].push(trip);
    }

    planedTrips.trips = memberTripsMap;

   await this.assignTripsToDrivers(planedTrips, selectedDrivers);

    // reset trips array after all planning
    planedTrips.trips = [];
    return planedTrips;

  }


  /**
 * Main method to assign trips to drivers.
 *
 * It iterates over trips (sorted by scheduleTime) and:
 * • Checks eligibility for each driver based on shift, fleet, funding, service area, and starting point.
 * • If a trip is from a client that already has an assigned driver (flag-based), it will only consider that driver.
 * • For each candidate driver, it ensures the trip fits into their current route.
 * • Finally, it chooses the best driver (minimizing added travel distance) and assigns the trip.
 *
 * @param {Array} trips - Array of trip objects.
 * @param {Array} drivers - Array of driver objects.
 * @returns {Object} A mapping from driver IDs to arrays of assigned trips.
 */

  async assignTripsToDrivers(planedTrips, drivers) {
    for (const clientId in planedTrips.trips) {
      const clientTrips = planedTrips.trips[clientId]
      // Determine candidate drivers
      // let candidateDrivers = drivers.filter(driver =>
      //   clientTrips.every(trip => this.isTripEligibleForDriver(planedTrips, trip, driver))
      // );

      let candidateDrivers = drivers.filter(driver => {
        const firstTrip = clientTrips[0];
        return this.isTripEligibleForDriver(planedTrips, firstTrip, driver);
      });

      if (!candidateDrivers.length) {
        planedTrips.nonCompatible.push(...clientTrips);
        console.warn(`Client ${clientId}. could not be assigned based on current criteria.`);
        continue;
      }

      // Find the best driver for all trips
      let chosenDriver = null;
      const allDriversNearestTo = {};
      let feasibleDrivers: any = [];

      for (const trip of clientTrips) {
        const driversForTrip = await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);


        if (feasibleDrivers.length === 0) {
          feasibleDrivers = driversForTrip;
        } else {
          feasibleDrivers = feasibleDrivers.filter(driver =>
            driversForTrip.some((d: any) => d._id === driver._id)
          );
        }

      }


      for (const item in allDriversNearestTo) {
        const trip = clientTrips.find(trip => trip._id === item);
        if (feasibleDrivers.length > 0) {
          chosenDriver = await this.chooseDriverForTrip(
            feasibleDrivers,
            allDriversNearestTo,
            trip,
            planedTrips.compatible
          );
        }
      }






      if (!chosenDriver) {
        planedTrips.nonCompatible.push(...clientTrips);
        console.warn(`Client ${clientId}. could not be assigned based on current criteria.`);
        continue;
      }

      // Assign all trips to the chosen driver
      if (!planedTrips.compatible[chosenDriver._id]) {
        planedTrips.compatible[chosenDriver._id] = {
          driver: chosenDriver,
          trips: []
        };
      }

      for (const trip of clientTrips) {
        const { distance } = await this.calculateDistance(
          trip.jobOriginLatitude,
          trip.jobOriginLongitude,
          trip.jobDestinationLatitude,
          trip.jobDestinationLongitude
        );

        planedTrips.driversDistance[chosenDriver._id] = planedTrips.driversDistance[chosenDriver._id] || 0;
        planedTrips.driversDistance[chosenDriver._id] += distance;
        planedTrips.compatible[chosenDriver._id].trips.push(trip);
      }

    }

    return planedTrips;
  }





  /**
   * Check if the driver meets fleet, funding, service area, and starting point requirements.
   *
   * @param {Object} trip - Trip object.
   * @param {Object} driver - Driver object.
   * @param {Number} startingPointThreshold - Maximum acceptable distance (in miles) from the driver's starting point to the trip’s pickup.
   */
  isTripEligibleForDriver(planedTrips, selectedTrip, driver, startingPointThreshold = 10) {

    let isCompatible = false;
    let logs = {};
    const isFundingSourceWiseExist = this.fundingSourcesWiseTrip(selectedTrip, driver);
    logs = { ...logs, isFundingSourceWiseExist };
    if (isFundingSourceWiseExist) {
      const isDriverShiftWiseExist = this.checkDriverShift(selectedTrip, driver);
      logs = { ...logs, isDriverShiftWiseExist };
      if (isDriverShiftWiseExist) {
        const isServiceAreasWiseExist = this.serviceAreasWiseTrip(selectedTrip, driver);
        logs = { ...logs, isServiceAreasWiseExist };
        if (isServiceAreasWiseExist) {
          const isSpaceTypeWiseExist = this.spaceTypeWiseTrip(selectedTrip, driver);
          logs = { ...logs, isSpaceTypeWiseExist };
          if (isSpaceTypeWiseExist) {
            const isGenderWiseExist = this.genderWiseTrip(selectedTrip, driver);
            logs = { ...logs, isGenderWiseExist };
            if (isGenderWiseExist) {
              if (!planedTrips.driversDistance[driver._id]) planedTrips.driversDistance[driver._id] = 0;
              const isMaxFactor = this.checkTripMaxFactor(planedTrips, driver, planedTrips.driversDistance[driver._id]);
              logs = { ...logs, isMaxFactor };
              if (isMaxFactor) {
                isCompatible = true;
              }
            }
          }
        }
      }
    }
    // // 5. Ensure the driver's starting point is close enough to the trip's pickup location.
    // const { latitude: startLat, longitude: startLon } = driver.startingPointAddress;
    // const { jobOriginLatitude: tripPickupLat, jobOriginLongitude: tripPickupLon } = trip;
    // const distanceFromStart = this.haversineDistance(startLat, startLon, tripPickupLat, tripPickupLon);
    // if (distanceFromStart > startingPointThreshold) {
    //   return false;
    // }

    // create Trip logs
    if (!isCompatible) {
      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs
          }]
        }
      }
    }

    return isCompatible;
  }

  checkDriverShift(selectedTrip, driver) {
    let isExist = false;
    const start = moment(this.preData.date).startOf('day');
    const end = moment(this.preData.date).endOf('day');

    if (this.shiftMapper[driver._id] && this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
      const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin) {
        start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });
        end.set({ hour: checkTodayShift.checkout.split(':')[0], minute: checkTodayShift.checkout.split(':')[1] });

        if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isBetween(start, end)) {
          isExist = true;
        }

      }
    }
    return isExist;
  }

  checkTripMaxFactor(planedTrips, driver, totalDistance) {
    let isExecute = true;
    // total trips check
    if (this.violation) {
      let numberOfTrips = true;
      if (this.violation && this.violation.maxPerRun) {
        if (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) {
          if (planedTrips.compatible[driver._id].trips.length >= this.violation.maxPerRun) {
            numberOfTrips = false
          }
        }

      }

      let numberOfTripsMiles = true;
      if (this.violation && this.violation.maxDistancePerRun) {
        if (totalDistance >= this.violation.maxDistancePerRun) {
          numberOfTripsMiles = false
        }
      }

      isExecute = (numberOfTrips && numberOfTripsMiles);
    }

    return isExecute;
  }

  fundingSourcesWiseTrip(selectedTrip, driver) {
    let isExist = false;
    const isfundingSource = driver.fundingSources.some(d => d.name === selectedTrip.cooperate && moment(this.preData.date).isBetween(moment(d.validityRange[0]).tz(this.user.timeZone).subtract(1,'day'), moment(d.validityRange[1]).tz(this.user.timeZone).add(1,'day')));
    if (selectedTrip.cooperate && isfundingSource) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (this.preFleet[driverFleetId] && this.preFleet[driverFleetId].fundingSources && this.preFleet[driverFleetId].fundingSources.includes(selectedTrip.cooperate)) {
          isExist = true;
        }
      }
    }
    return isExist;
  }

  serviceAreasWiseTrip(selectedTrip, driver) {
    let isExist = false;
    if (selectedTrip.serviceArea && this.shiftMapper[driver._id] &&this.shiftMapper[driver._id].serviceAreas.includes(selectedTrip.serviceArea)) {
      isExist = true;
    }
    return isExist;
  }

  spaceTypeWiseTrip(selectedTrip, driver) {
    let isExist = false;

    if (this.violation && !this.violation.isCapacityViolation) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (selectedTrip.spaceType && driverFleetId && this.preFleet[driverFleetId]) {
          isExist = this.preFleet[driverFleetId].capacities.some(capacity => capacity.spaceType === selectedTrip.spaceType);
        }
      }
    } else {
      isExist = true;
    }
    return isExist;
  }

  genderWiseTrip(selectedTrip, driver) {
    let isExist = true;

    if (selectedTrip.priorityClient.isPrefferedFemale) {
      isExist = driver.gender.toLowerCase() === 'female'
    }

    if (selectedTrip.preferredDriver) {
      isExist = driver._id === selectedTrip.priorityClient.preferredDriver;
    }
    return isExist;

  }

  /**
   * Check if a new trip can be scheduled anywhere in a driver’s current route.
   *
   * It ensures that the time gap between trips is sufficient to accommodate travel time (plus a relaxation margin).
   *
   * @param {Object} trip - New trip to evaluate.
   * @param {Array} assignedTrips - Array of trips already assigned to this driver (sorted by scheduleTime).
   * @param {Number} tripCheckMargin - Extra time (in minutes) to allow between trips.
   * @returns {Boolean} - Whether the trip can fit in the route.
   */
  async canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo, tripCheckMargin = 3) {
    let isAllow = false;
    let nearestTo = {};
    const assignedTrips = planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips || [];

   if (assignedTrips.length === 0) {
      isAllow = await this.firstTripPossibility(driver, trip);
      if (isAllow)
       nearestTo = { driverId: driver._id, position: null };
    }

    if (assignedTrips.length !== 0) {
      if (this.violation) {
        if (!isAllow) {
          isAllow = await this.addBeforeTrips(trip, assignedTrips);
          if (isAllow)
            nearestTo = { driverId: driver._id, position: null };
        }

        if (!isAllow) {
          const nearest = await this.betweenTrips(trip, assignedTrips);
          isAllow = nearest.isAllow;
          if (isAllow)
            nearestTo = { driverId: driver._id, position: nearest.to };
        }

        if (!isAllow) {
          isAllow = await this.afterTrips(trip, assignedTrips);
          if (isAllow)
            nearestTo = { driverId: driver._id, position: planedTrips.compatible[driver._id].trips[planedTrips.compatible[driver._id].trips.length - 1]._id };
        }
      } else {
        isAllow = true;
        nearestTo = { driverId: driver._id, position: planedTrips.compatible[driver._id].trips[planedTrips.compatible[driver._id].trips.length - 1]._id };
      }
    }
    // Create logs if trip is not allowed
    if (!isAllow) {
      let logs = {
        isFundingSourceWiseExist: true,
        isDriverShiftWiseExist: true,
        isServiceAreasWiseExist: true,
        isSpaceTypeWiseExist: true,
        istimeWiseTripExist: false,
      };

      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: trip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: trip,
            logs
          }]
        };
      }
    } else {
      if (!allDriversNearestTo[trip._id]) { allDriversNearestTo[trip._id] = []; }
      allDriversNearestTo[trip._id].push(nearestTo);
    }

    return isAllow;
  }

  async firstTripPossibility(driver, trip) {
    const start = moment(this.preData.date).startOf('day');
    if (driver.shifts && driver.shifts.length) {
      const checkTodayShift = driver.shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin) {
        start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });

        const firstTripStartTime = moment(trip.appointmentTime).clone();
        const tripTravelTrip = await this.calculateDistance(
          trip.jobOriginLatitude,
          trip.jobOriginLongitude,
          trip.jobDestinationLatitude,
          trip.jobDestinationLongitude
        );

        firstTripStartTime.subtract(tripTravelTrip.duration, 'minutes');

        if (this.preData.spaceTypes[trip.spaceType]) {
          let loadTime = this.preData.spaceTypes[trip.spaceType].loadTime;
          if (loadTime) {
            loadTime = loadTime.split(':');
            firstTripStartTime.subtract(loadTime[1], 'minutes').subtract(loadTime[0], 'hours');
          }
        }

        const { latitude: startLat, longitude: startLon } = driver.startingPointAddress;

        const travelTimeToFirstTrip = await this.calculateDistance(
          startLat,
          startLon,
          trip.jobOriginLatitude,
          trip.jobOriginLongitude
        );

        firstTripStartTime.subtract(travelTimeToFirstTrip.duration, 'minutes');
        return start.isSameOrBefore(firstTripStartTime);
      }
    }
    return false;
  }

 async addBeforeTrips(trip, assignedTrips) {
    const firstTrip = assignedTrips[0];
    const firstTripStartTime = moment(firstTrip.appointmentTime).clone();

    const secondtravelTrip = await this.calculateDistance(
      firstTrip.jobOriginLatitude,
      firstTrip.jobOriginLongitude,
      firstTrip.jobDestinationLatitude,
      firstTrip.jobDestinationLongitude
    );

    firstTripStartTime.subtract(secondtravelTrip.duration, 'minutes');

    if (this.preData.spaceTypes[firstTrip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[firstTrip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        firstTripStartTime.subtract(unloadTime[1], 'minutes').subtract(unloadTime[0], 'hours');
      }
    }


    let newTripAPPT = moment(trip.appointmentTime).clone();

    if (this.preData.spaceTypes[trip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[trip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        newTripAPPT.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
      }
    }

    if (this.violation && this.violation.breakCushion) {
      newTripAPPT.add(this.violation.breakCushion, 'minutes');
    }

    const travelTimeToFirstTrip = await this.calculateDistance(
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude,
      firstTrip.jobOriginLatitude,
      firstTrip.jobOriginLongitude
    );
    newTripAPPT.add(travelTimeToFirstTrip.duration, 'minutes');

    return newTripAPPT.isSameOrBefore(firstTripStartTime);
  }

  async afterTrips(trip, assignedTrips) {
    const lastTrip = assignedTrips[assignedTrips.length - 1];
    const lastTripEndTime = moment(lastTrip.appointmentTime).clone();

    if (this.preData.spaceTypes[lastTrip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[lastTrip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        lastTripEndTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
      }
    }

    if (this.violation && this.violation.breakCushion) {
      lastTripEndTime.add(this.violation.breakCushion, 'minutes');
    }


    let newTripStartTime = moment(trip.appointmentTime).clone();

    if (this.preData.spaceTypes[trip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[trip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        newTripStartTime.subtract(unloadTime[1], 'minutes').subtract(unloadTime[0], 'hours');
      }
    }
// Previous to New Trip
    const travelTimeToNewTrip = await this.calculateDistance(
      lastTrip.jobDestinationLatitude,
      lastTrip.jobDestinationLongitude,
      trip.jobOriginLatitude,
      trip.jobOriginLongitude
    );
    newTripStartTime.subtract(travelTimeToNewTrip.duration, 'minutes');

//  New Trip pickup to drop off
    const travelTimeNewPickupToDropOff = await this.calculateDistance(
      trip.jobOriginLatitude,
      trip.jobOriginLongitude,
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude,
    );
    newTripStartTime.subtract(travelTimeNewPickupToDropOff.duration, 'minutes');


    return lastTripEndTime.isSameOrBefore(newTripStartTime);
  }


  async betweenTrips(trip, assignedTrips) {
    let nearest = { to: null, isAllow: false };

    const tripStartTime = moment(trip.appointmentTime).clone();
    const tripEndTime = moment(trip.appointmentTime).clone();
    const selectedTripDistance = await this.calculateDistance(
      trip.jobOriginLatitude,
      trip.jobOriginLongitude,
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude
    );
    tripStartTime.subtract(selectedTripDistance.duration, 'minutes');

    if (this.preData.spaceTypes[trip.spaceType]) {
      let loadTime = this.preData.spaceTypes[trip.spaceType].loadTime;
      if (loadTime) {
        loadTime = loadTime.split(':');
        tripStartTime.subtract(loadTime[1], 'minutes').add(loadTime[0], 'hours');
      }
    }

    if (this.preData.spaceTypes[trip.spaceType]) {
      let unloadTime = this.preData.spaceTypes[trip.spaceType].unloadTime;
      if (unloadTime) {
        unloadTime = unloadTime.split(':');
        tripEndTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
      }
    }


    for (let i = 0; i < assignedTrips.length - 1; i++) {
      const firstTrip = assignedTrips[i];
      const nextTrip = assignedTrips[i + 1];
      // first
      const firstTripEndTime = moment(firstTrip.appointmentTime).clone();

      if (this.preData.spaceTypes[firstTrip.spaceType]) {
        let unloadTime = this.preData.spaceTypes[firstTrip.spaceType].unloadTime;
        if (unloadTime) {
          unloadTime = unloadTime.split(':');
          firstTripEndTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
        }
      }

      if (this.violation && this.violation.breakCushion) {
        firstTripEndTime.add(this.violation.breakCushion, 'minutes');
      }


      // next
      const nextTripStartTime = moment(nextTrip.appointmentTime).clone();

      const travelTimeBetween = await this.calculateDistance(
        nextTrip.jobOriginLatitude,
        nextTrip.jobOriginLongitude,
        nextTrip.jobDestinationLatitude,
        nextTrip.jobDestinationLongitude
      );

      nextTripStartTime.subtract(travelTimeBetween.duration, 'minutes');


      if (this.preData.spaceTypes[nextTrip.spaceType]) {
        let loadTime = this.preData.spaceTypes[nextTrip.spaceType].loadTime;
        if (loadTime) {
          loadTime = loadTime.split(':');
          nextTripStartTime.subtract(loadTime[1], 'minutes').add(loadTime[0], 'hours');
        }
      }

      if (this.violation && this.violation.breakCushion) {
        nextTripStartTime.subtract(this.violation.breakCushion, 'minutes');
      }



      // check distance between first and trip
      const travelTimeBetweenFirstAndTrip = await this.calculateDistance(
        firstTrip.jobDestinationLatitude,
        firstTrip.jobDestinationLongitude,
        trip.jobOriginLatitude,
        trip.jobOriginLongitude
      );

      firstTripEndTime.add(travelTimeBetweenFirstAndTrip.duration, 'minutes');
      // check distance between trip and next
      const travelTimeBetweenTripAndNext = await this.calculateDistance(
        trip.jobDestinationLatitude,
        trip.jobDestinationLongitude,
        nextTrip.jobOriginLatitude,
        nextTrip.jobOriginLongitude
      );

      nextTripStartTime.subtract(travelTimeBetweenTripAndNext.duration, 'minutes');


      if (firstTripEndTime.isSameOrBefore(tripStartTime) && tripEndTime.isSameOrBefore(nextTripStartTime)) {
        return nearest = { to: firstTrip._id, isAllow: true };
      }
    }

    return nearest;
  }

  /**
   * From a list of feasible drivers, choose the best one based on the minimal extra travel distance.
   *
   * The extra distance is measured from either the driver's starting point (if no trips are yet assigned)
   * or the last trip’s dropoff location.
   *
   * @param {Array} feasibleDrivers - Array of driver objects that passed eligibility and feasibility checks.
   * @param {Object} trip - The trip to assign.
   * @param {Object} assignments - Mapping from driver._id to an array of assigned trips.
   */
 async chooseDriverForTrip( feasibleDrivers, allDriversNearestTo, selectedTrip, compatible) {
    // check trip with possition of other trip of drivers.
    let bestDriver = null;
    let minExtraDistance = Infinity;

    for (let driver of feasibleDrivers) {
      let referencePoint = null;


      // If the driver already has trips, use the last trip's dropoff location.
      if (compatible[driver._id] && compatible[driver._id].trips && compatible[driver._id].trips.length > 0) {

        let lastTrip;
        const nearestTo = allDriversNearestTo[selectedTrip._id].find(item => item.driverId === driver._id);
        if (!nearestTo.position) {
          referencePoint = {
            lat: driver.startingPointAddress.latitude,
            lon: driver.startingPointAddress.longitude,
          };
        } else {
          lastTrip = compatible[driver._id].trips.find(trip => trip._id === nearestTo.position);
          referencePoint = {
            lat: lastTrip.jobDestinationLatitude,
            lon: lastTrip.jobDestinationLongitude,
          };
        }

      } else {
        // Otherwise, use the driver's starting point.
        referencePoint = {
          lat: driver.startingPointAddress.latitude,
          lon: driver.startingPointAddress.longitude,
        };
      }

      const checkpossibleDistance = await this.calculateDistance(referencePoint.lat, referencePoint.lon, selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude);
      if (checkpossibleDistance.distance < minExtraDistance) {
        minExtraDistance = checkpossibleDistance.distance;
        bestDriver = driver;
      }
    }

    return bestDriver;
  }

  //  checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
  //   const feasibleDrivers = candidateDrivers.filter(async (driver) => {
  //     const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
  //     return result;
  //   });

  //   return feasibleDrivers;
  // }

  async checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
    const feasibleDrivers = await Promise.all(
      candidateDrivers.map(async (driver) => {
        const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
        return result ? driver : null;
      })
    );
    return feasibleDrivers.filter(driver => driver !== null);
  }


  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2))});
    }
    return resutl;
  }


  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }
}



// Full Backup JAva


// import java.text.SimpleDateFormat;
// import java.util.Collection;
// import java.util.Date;

// import com.graphhopper.jsprit.core.algorithm.VehicleRoutingAlgorithm;
// import com.graphhopper.jsprit.core.algorithm.box.Jsprit;
// import com.graphhopper.jsprit.core.problem.Location;
// import com.graphhopper.jsprit.core.problem.VehicleRoutingProblem;
// import com.graphhopper.jsprit.core.problem.job.Shipment;
// import com.graphhopper.jsprit.core.problem.solution.VehicleRoutingProblemSolution;
// import com.graphhopper.jsprit.core.problem.solution.route.activity.TimeWindow;
// import com.graphhopper.jsprit.core.problem.vehicle.VehicleImpl;
// import com.graphhopper.jsprit.core.problem.vehicle.VehicleTypeImpl;
// import com.graphhopper.jsprit.core.util.Solutions;
// import java.util.Map;
// import java.util.HashMap;
// import com.graphhopper.jsprit.core.problem.solution.route.activity.TourActivity;
// import java.util.TimeZone;
// import java.text.ParseException;
// import com.graphhopper.jsprit.core.problem.cost.TransportCost;
// import com.graphhopper.jsprit.core.problem.Location;


// import java.util.*;


// public class DemoApplication {
//          private static final String API_KEY = "";

//     public static void main(String[] args) {

//         Map<String, Object> shipmentPersonMap = new HashMap<>();

//         // Define vehicle types
//         VehicleTypeImpl vehicleType1 = VehicleTypeImpl.Builder.newInstance("sedan-type")
//                 .addCapacityDimension(0, 3) // Example capacity
//                 .build();

//         VehicleTypeImpl vehicleType2 = VehicleTypeImpl.Builder.newInstance("van-type")
//                 .addCapacityDimension(0, 3) // Example capacity
//                 .build();

//         // Problem builder
//         VehicleRoutingProblem.Builder problemBuilder = VehicleRoutingProblem.Builder.newInstance();

//         VehicleImpl vehicleS = VehicleImpl.Builder.newInstance("Sedan-S")
//             .setStartLocation(Location.newInstance(37.76336467845344, -121.20957167433548))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleS);


//         VehicleImpl vehicleU = VehicleImpl.Builder.newInstance("Sedan-U")
//             .setStartLocation(Location.newInstance(37.76762820828527, -121.91164887433541))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleU);


//         VehicleImpl vehicleY = VehicleImpl.Builder.newInstance("Sedan-Y")
//             .setStartLocation(Location.newInstance(37.97469675999781, -121.69539605025963))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleY);


//         VehicleImpl vehicleR = VehicleImpl.Builder.newInstance("Sedan-R")
//             .setStartLocation(Location.newInstance(37.97762159840369, -121.83377441850669))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleR);


//         VehicleImpl vehicleE = VehicleImpl.Builder.newInstance("Sedan-E")
//             .setStartLocation(Location.newInstance(38.01314841880288, -121.82377121850507))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleE);


//         VehicleImpl vehicleV = VehicleImpl.Builder.newInstance("Sedan-V")
//             .setStartLocation(Location.newInstance(37.94481231380096, -122.3397223031637))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleV);


//         VehicleImpl vehicleM = VehicleImpl.Builder.newInstance("Sedan-M")
//             .setStartLocation(Location.newInstance(38.03503558173878, -121.89101403199594))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleM);


//         VehicleImpl vehicleP = VehicleImpl.Builder.newInstance("Sedan-P")
//             .setStartLocation(Location.newInstance(37.68554039654247, -122.1599772185193))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleP);


//         VehicleImpl vehicleZ = VehicleImpl.Builder.newInstance("Sedan-Z")
//             .setStartLocation(Location.newInstance(37.68563379267571, -122.15986993015856))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleZ);


//         VehicleImpl vehicleA = VehicleImpl.Builder.newInstance("Sedan-A")
//             .setStartLocation(Location.newInstance(37.64129561959203, -122.07508920317682))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleA);


//         VehicleImpl vehicleT = VehicleImpl.Builder.newInstance("Sedan-T")
//             .setStartLocation(Location.newInstance(38.00934114610546, -121.89788384548888))
//             .setType(vehicleType1)
//           .build();
//           problemBuilder.addVehicle(vehicleT);




//         // Input data
//         // Input data
//         Appointment[] data = {
//                 new Appointment("2025-04-10T12:00:00.000Z", "2025-04-10T12:35:00.000Z", 37.9106359, -122.0450316,
//                         37.9273841, -122.0310002,
//                         new PriorityClient("PATRICK TREANOR = M6R5C05U (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T14:52:00.000Z", "2025-04-10T15:45:00.000Z", 37.9170832, -121.6220872,
//                         37.9847194, -122.0362082,
//                         new PriorityClient("DAWNA  TOLLIVER = M9AH6IVG (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T15:00:00.000Z", "2025-04-10T15:30:00.000Z", 37.9560557, -122.3252246,
//                         37.92545210000001, -122.3565665,
//                         new PriorityClient("Kerry Thompson = M8YPOP8U (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T15:15:00.000Z", "2025-04-10T16:10:00.000Z", 37.81417039999999, -122.2519478,
//                         37.7811341, -122.2318299,
//                         new PriorityClient("Carter Lavonda = M7ZDAVYL (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T15:40:00.000Z", "2025-04-10T16:40:00.000Z", 37.92545210000001, -122.3565665,
//                         37.9560557, -122.3252246,
//                         new PriorityClient("Kerry Thompson = M8YPOP8U  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T15:45:00.000Z", "2025-04-10T16:30:00.000Z", 37.9261753, -122.3385394,
//                         37.931722, -122.3299732,
//                         new PriorityClient("Martha Hernandez = M6R5VQDZ (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T16:15:00.000Z", "2025-04-10T16:45:00.000Z", 37.9961118, -121.8948085,
//                         37.9701786, -121.7857419,
//                         new PriorityClient("Green Betty = M6R6QQC6 (LEG-A)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T16:30:00.000Z", "2025-04-10T17:30:00.000Z", 37.8766701, -122.0746161,
//                         37.9299849, -122.0293006,
//                         new PriorityClient("Troy Iwinsti = M6S9R9ED (LEG-A)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T16:30:00.000Z", "2025-04-10T17:30:00.000Z", 37.8575093, -122.2663192,
//                         37.9339156, -122.3595225,
//                         new PriorityClient("Pitre Brenda K = M9AH7F16 (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T17:00:00.000Z", "2025-04-10T17:20:00.000Z", 37.9807288, -121.8233222,
//                         37.984556, -121.8038109,
//                         new PriorityClient("Lisa Naas = M6R2VDWZ (LEG-A)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T17:00:00.000Z", "2025-04-10T17:30:00.000Z", 37.9273841, -122.0310002,
//                         37.9106359, -122.0450316,
//                         new PriorityClient("PATRICK TREANOR = M6R5C05U  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T17:30:00.000Z", "2025-04-10T18:30:00.000Z", 37.9847194, -122.0362082,
//                         37.9170832, -121.6220872,
//                         new PriorityClient("DAWNA  TOLLIVER = M9AH6IVG  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T17:30:00.000Z", "2025-04-10T18:05:00.000Z", 37.7472895, -122.1526652,
//                         37.7940963, -122.2725223,
//                         new PriorityClient("BEVERLY DUMMETT = M9AH8BU2 (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T17:40:00.000Z", "2025-04-10T18:40:00.000Z", 37.984556, -121.8038109,
//                         37.9807288, -121.8233222,
//                         new PriorityClient("Lisa Naas = M6R2VDWZ  (LEG-B)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T18:00:00.000Z", "2025-04-10T19:00:00.000Z", 37.9339156, -122.3595225,
//                         37.8575093, -122.2663192,
//                         new PriorityClient("Pitre Brenda K = M9AH7F16  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T19:00:00.000Z", "2025-04-10T20:00:00.000Z", 38.008221, -121.8598604,
//                         37.98127519999999, -122.0321823,
//                         new PriorityClient("Tanya Rae = M8QD8WGE (LEG-A)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T19:00:00.000Z", "2025-04-10T19:30:00.000Z", 37.989354, -121.7564306,
//                         37.9813955, -122.0323355,
//                         new PriorityClient("Ricardo Rikki Nunez = M98SD7NZ (LEG-A)", "9259337970", "9259337970", "0",
//                                 "", 179, "male")),
//                 new Appointment("2025-04-10T19:30:00.000Z", "2025-04-10T20:00:00.000Z", 37.8766701, -122.0746161,
//                         37.9273841, -122.0310002,
//                         new PriorityClient("PAUL BELL = M6QY6MY0 (LEG-A)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T19:45:00.000Z", "2025-04-10T20:45:00.000Z", 37.7811341, -122.2318299,
//                         37.81417039999999, -122.2519478,
//                         new PriorityClient("Carter Lavonda = M7ZDAVYL  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T20:30:00.000Z", "2025-04-10T21:30:00.000Z", 37.931722, -122.3299732,
//                         37.9261753, -122.3385394,
//                         new PriorityClient("Martha Hernandez = M6R5VQDZ  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T20:30:00.000Z", "2025-04-10T21:15:00.000Z", 37.9855389, -122.0025624,
//                         37.92486780000001, -122.0253844,
//                         new PriorityClient("Liubov Stepanova = M97LCF6W (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T20:30:00.000Z", "2025-04-10T21:30:00.000Z", 37.9813955, -122.0323355,
//                         37.989354, -121.7564306,
//                         new PriorityClient("Ricardo Rikki Nunez = M98SD7NZ  (LEG-B)", "9259337970", "9259337970", "0",
//                                 "", 179, "male")),
//                 new Appointment("2025-04-10T20:45:00.000Z", "2025-04-10T21:45:00.000Z", 37.9701786, -121.7857419,
//                         37.9961118, -121.8948085,
//                         new PriorityClient("Green Betty = M6R6QQC6  (LEG-B)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T21:15:00.000Z", "2025-04-10T22:00:00.000Z", 37.9005571, -122.0533118,
//                         37.9847194, -122.0362082,
//                         new PriorityClient("Tekle Yohannes = M97LDNZG (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T21:15:00.000Z", "2025-04-10T22:00:00.000Z", 37.9346445, -122.0572116,
//                         37.9397563, -122.0576395,
//                         new PriorityClient("Cassaundrah Mitchellowens = M98SFJNG (LEG-A)", "9259337970", "9259337970",
//                                 "0", "", 179, "male")),
//                 new Appointment("2025-04-10T21:30:00.000Z", "2025-04-10T22:00:00.000Z", 37.9366866, -122.3547755,
//                         37.842408, -122.2907306,
//                         new PriorityClient("CLAUDIA  GEATHERS = M9AH9CEW (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T21:30:00.000Z", "2025-04-10T21:30:00.000Z", 37.9106359, -122.0450316,
//                         37.9113897, -122.0400601,
//                         new PriorityClient("Justino  Alvares = M9AMW271 (LEG-A)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T21:45:00.000Z", "2025-04-10T22:30:00.000Z", 37.7940963, -122.2725223,
//                         37.7472895, -122.1526652,
//                         new PriorityClient("BEVERLY DUMMETT = M9AH8BU2  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T22:00:00.000Z", "2025-04-10T23:00:00.000Z", 37.98127519999999, -122.0321823,
//                         38.008221, -121.8598604,
//                         new PriorityClient("Tanya Rae = M8QD8WGE  (LEG-B)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T22:15:00.000Z", "2025-04-10T23:15:00.000Z", 37.92486780000001, -122.0253844,
//                         37.9855389, -122.0025624,
//                         new PriorityClient("Liubov Stepanova = M97LCF6W  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T22:30:00.000Z", "2025-04-10T23:30:00.000Z", 37.9299849, -122.0293006,
//                         37.8766701, -122.0746161,
//                         new PriorityClient("Troy Iwinsti = M6S9R9ED  (LEG-B)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-10T22:30:00.000Z", "2025-04-10T23:30:00.000Z", 37.9113897, -122.0400601,
//                         37.9106359, -122.0450316,
//                         new PriorityClient("Justino  Alvares = M9AMW271  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-10T23:00:00.000Z", "2025-04-11T00:00:00.000Z", 37.9847194, -122.0362082,
//                         37.9005571, -122.0533118,
//                         new PriorityClient("Tekle Yohannes = M97LDNZG  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male")),
//                 new Appointment("2025-04-11T00:00:00.000Z", "2025-04-11T00:30:00.000Z", 37.9273841, -122.0310002,
//                         37.8766701, -122.0746161,
//                         new PriorityClient("PAUL BELL = M6QY6MY0  (LEG-B)", "9259337970", "9259337970", "0", "", 179,
//                                 "male")),
//                 new Appointment("2025-04-11T00:15:00.000Z", "2025-04-11T01:15:00.000Z", 37.9397563, -122.0576395,
//                         37.9346445, -122.0572116,
//                         new PriorityClient("Cassaundrah Mitchellowens = M98SFJNG  (LEG-B)", "9259337970", "9259337970",
//                                 "0", "", 179, "male")),
//                 new Appointment("2025-04-11T05:00:00.000Z", "2025-04-11T06:00:00.000Z", 37.842408, -122.2907306,
//                         37.9366866, -122.3547755,
//                         new PriorityClient("CLAUDIA  GEATHERS = M9AH9CEW  (LEG-B)", "9259337970", "9259337970", "0", "",
//                                 179, "male"))
//         };

//         // Add jobs (pickups and deliveries)
//         for (int i = 0; i < data.length; i++) {
//             Appointment appointment = data[i];

//             // Time Windows (use scheduleTime for pickup and appointmentTime for delivery)
//             TimeWindow pickupWindow = TimeWindow.newInstance(parseTime(appointment.getScheduleTime()),
//                     parseTime(appointment.getScheduleTime()) + 30 * 60 * 1000);
//             TimeWindow deliveryWindow = TimeWindow.newInstance(parseTime(appointment.getAppointmentTime()),
//                     parseTime(appointment.getAppointmentTime()) + 30 * 60 * 1000);

//             // Create the shipment (job)
//             Shipment shipment = Shipment.Builder.newInstance(appointment.getPriorityClient().getDisplayName() + "-" + i)
//                     .setPickupLocation(Location.newInstance(appointment.getJobOriginLatitude(),
//                             appointment.getJobOriginLongitude()))
//                     .setDeliveryLocation(Location.newInstance(appointment.getJobDestinationLatitude(),
//                             appointment.getJobDestinationLongitude()))
//                     .setPickupTimeWindow(pickupWindow)
//                     .setDeliveryTimeWindow(deliveryWindow)
//                     .build();

//             Map<String, Object> person = new HashMap<>();
//             person.put("name", appointment.getPriorityClient().getDisplayName());
//             person.put("startTime", appointment.getScheduleTime());
//             person.put("endtime", appointment.getAppointmentTime());

//             shipmentPersonMap.put(appointment.getPriorityClient().getDisplayName() + "-" + i, person);

//             // Add the job (shipment) to the problem
//             problemBuilder.addJob(shipment);

//             // Optionally use the index (i) for logging, debugging, or further logic
//             System.out.println("Index: " + i + " - Appointment: " + appointment.getPriorityClient().getDisplayName());
//         }

//         // Build the problem
//         VehicleRoutingProblem problem = problemBuilder.build();

//         // Solve it
//         VehicleRoutingAlgorithm algorithm = Jsprit.createAlgorithm(problem);
//         Collection<VehicleRoutingProblemSolution> solutions = algorithm.searchSolutions();

//         // Print the result with more details
//         VehicleRoutingProblemSolution best = Solutions.bestOf(solutions);

//         best.getRoutes().forEach(route -> {
//             System.out.println("Route for vehicle: " + route.getVehicle().getId());
//             route.getActivities().forEach(activity -> {

//                 if (activity instanceof TourActivity.JobActivity) {
//                     TourActivity.JobActivity jobActivity = (TourActivity.JobActivity) activity;
//                     String jobId = jobActivity.getJob().getId();

//                     Map<String, Object> retrievedPerson = (Map<String, Object>) shipmentPersonMap.get(jobId);
//                     String name = (String) retrievedPerson.get("name");
//                     String startTime = (String) retrievedPerson.get("startTime");
//                     String endTime = (String) retrievedPerson.get("endtime");

//                     String result = activity.getName() == "pickupShipment" ? startTime : endTime;
//                     try {
//                         String timeString = result;

//                         // Define the input format (ISO 8601 with 'Z' for UTC)
//                         SimpleDateFormat inputFormat = new SimpleDateFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
//                         // inputFormat.setTimeZone(TimeZone.getTimeZone("UTC"));

//                         // Parse the date string into a Date object

//                         Date date = inputFormat.parse(timeString);

//                         // Define the output format (only time)
//                         SimpleDateFormat outputFormat = new SimpleDateFormat("HH:mm");

//                         // Format the Date object into a time string
//                         String time = outputFormat.format(date);

//                         System.out.println(" -> " + name + " - " + time + " - " + activity.getName() + " at " +
//                                 activity.getLocation().getCoordinate().getY() + "," +
//                                 activity.getLocation().getCoordinate().getX());

//                     } catch (ParseException e) {
//                         e.printStackTrace();
//                     }
//                 } else {
//                     // Optional: Handle other activity types (e.g., Start, End)
//                     System.out.println(" -> (Non-job activity) " + activity.getName() + " at " +
//                             activity.getLocation().getCoordinate().getY() + "," +
//                             activity.getLocation().getCoordinate().getX());
//                 }

//                 // String activityName = act.getName();
//                 // String locationInfo = act.getLocation().toString();

//                 // // Customize the output for Pickup and Delivery
//                 // if (activityName.equals("pickupShipment")) {
//                 // System.out.println(" - Pickup at " + locationInfo);
//                 // } else if (activityName.equals("deliverShipment")) {
//                 // System.out.println(" - Deliver at " + locationInfo);
//                 // } else {
//                 // System.out.println(" - " + activityName + " at " + locationInfo);
//                 // }
//                 // System.out.println("personName -> " + activity.getName() + " at " +
//                 // activity.getLocation().getCoordinate().getY() + "," +
//                 // activity.getLocation().getCoordinate().getX());
//             });
//         });
//     }

//     private static long parseTime(String timeString) {
//         try {
//             return new SimpleDateFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'").parse(timeString).getTime();
//         } catch (Exception e) {
//             e.printStackTrace();
//             return 0;
//         }
//     }
// }

// // Define PriorityClient
// class PriorityClient {
//     private String displayName;
//     private String contactNumber;
//     private String cellPhone;
//     private String clientId;
//     private String email;
//     private Date dob;
//     private int weight;
//     private String gender;

//     // Constructor
//     public PriorityClient(String displayName, String contactNumber, String cellPhone, String clientId, String email,
//             int weight, String gender) {
//         this.displayName = displayName;
//         this.contactNumber = contactNumber;
//         this.cellPhone = cellPhone;
//         this.clientId = clientId;
//         this.email = email;
//         this.weight = weight;
//         this.gender = gender;
//     }

//     // Getters and Setters
//     public String getDisplayName() {
//         return displayName;
//     }

//     public void setDisplayName(String displayName) {
//         this.displayName = displayName;
//     }

//     public String getContactNumber() {
//         return contactNumber;
//     }

//     public void setContactNumber(String contactNumber) {
//         this.contactNumber = contactNumber;
//     }

//     public String getCellPhone() {
//         return cellPhone;
//     }

//     public void setCellPhone(String cellPhone) {
//         this.cellPhone = cellPhone;
//     }

//     public String getClientId() {
//         return clientId;
//     }

//     public void setClientId(String clientId) {
//         this.clientId = clientId;
//     }

//     public String getEmail() {
//         return email;
//     }

//     public void setEmail(String email) {
//         this.email = email;
//     }

//     public int getWeight() {
//         return weight;
//     }

//     public void setWeight(int weight) {
//         this.weight = weight;
//     }

//     public String getGender() {
//         return gender;
//     }

//     public void setGender(String gender) {
//         this.gender = gender;
//     }
// }

// // Define Appointment
// class Appointment {
//     private String scheduleTime;
//     private String appointmentTime;
//     private double jobDestinationLatitude;
//     private double jobDestinationLongitude;
//     private double jobOriginLatitude;
//     private double jobOriginLongitude;
//     private PriorityClient priorityClient;

//     public Appointment(String scheduleTime, String appointmentTime, double jobOriginLatitude, double jobOriginLongitude,
//             double jobDestinationLatitude, double jobDestinationLongitude, PriorityClient priorityClient) {
//         this.scheduleTime = scheduleTime;
//         this.appointmentTime = appointmentTime;
//         this.jobOriginLatitude = jobOriginLatitude;
//         this.jobOriginLongitude = jobOriginLongitude;
//         this.jobDestinationLatitude = jobDestinationLatitude;
//         this.jobDestinationLongitude = jobDestinationLongitude;
//         this.priorityClient = priorityClient;
//     }

//     // Getters
//     public String getScheduleTime() {
//         return scheduleTime;
//     }

//     public String getAppointmentTime() {
//         return appointmentTime;
//     }

//     public double getJobDestinationLatitude() {
//         return jobDestinationLatitude;
//     }

//     public double getJobDestinationLongitude() {
//         return jobDestinationLongitude;
//     }

//     public double getJobOriginLatitude() {
//         return jobOriginLatitude;
//     }

//     public double getJobOriginLongitude() {
//         return jobOriginLongitude;
//     }

//     public PriorityClient getPriorityClient() {
//         return priorityClient;
//     }
// }


